import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AppThunk } from '../store'
import { getTutorial, patchPassword } from '../../apis/tutorial'
import { setErrors } from '../common/errorsSlice'
import { ManagerInfo, PatchPasswordParams } from '../../types/tutorial'

interface managerInfoState extends ManagerInfo {
  isLoading: boolean
}

const initialState: Partial<managerInfoState> = {
  isLoading: true,
}

const managerInfoSlice = createSlice({
  name: 'managerInfo',
  initialState,
  reducers: {
    requestStart: (state) => {
      state.isLoading = true
      return state
    },
    getManagerInfoSuccess: (state, action: PayloadAction<ManagerInfo>) => {
      // eslint-disable-next-line no-param-reassign
      state = { ...state, ...action.payload }
      state.isLoading = false
      return state
    },
    requestFailure: (state) => {
      state.isLoading = false
      return state
    },
    resetState: () => initialState,
  },
})

export const {
  requestStart,
  getManagerInfoSuccess,
  requestFailure,
  resetState,
} = managerInfoSlice.actions

export const managerInfoReducer = managerInfoSlice.reducer

export const fetchManagerInfo = (): AppThunk => async (dispatch) => {
  dispatch(resetState())
  dispatch(requestStart())
  getTutorial()
    .then((result) => {
      dispatch(getManagerInfoSuccess(result))
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}

export const updatePassword = (
  params: PatchPasswordParams,
  callback: () => void,
  errorCallBack: () => void,
): AppThunk => async (dispatch) => {
  patchPassword(params)
    .then(() => {
      callback()
    })
    .catch((error) => {
      dispatch(setErrors(error))
      errorCallBack()
    })
}
